import Page from "../../../framework/Page";
import View from "../../../framework/View";

export default class OperatorView extends View {
    /**
     * @param {string} parentId
     * @param {string} elementId
     * @param {string} operator
     */
    constructor(parentId, elementId, operator) {
        super(parentId, elementId);

        /**
         * @constant
         * @type {string}
         */
        this.operator = operator;

        this.setInitialVisibility(true);
    }

    /**
     * @override
     */
    initializeView() {

        const parentElement = Page.getElement(this.parentId);

        ////////////////////////////////////
        // Operator
        ////////////////////////////////////

        const container = Page.createElement('div', parentElement, this.getElementId(), 'mine-damage-panel-operator-section');

        const header = Page.createElement('div', container, null, null);
        header.innerHTML += '&nbsp;';

        const body = Page.createElement('div', container, null, null);
        body.innerHTML = this.operator;

        super.initializeView();        
    }

    /**
     * @override
     * @returns {string}
     */
    getVisibileDisplayValue() {
        return 'inline-block'; // This is a span element.  Don't use display:block.
    }

}